import { createTRPCProxyClient, httpBatchLink, httpLink } from "@trpc/client";
import type { inferRouterInputs, inferRouterOutputs } from "@trpc/server";
import superJSON from "superjson";
import type { AppRouter } from "./router";

// Use single requests for Playwright to make it easier to match and
// handle requests.
const link = import.meta.env.MODE === "playwright" ? httpLink : httpBatchLink;

/**
 * Custom fetch that redirects to login on 401, preventing unhandled errors.
 */
const fetchWithAuthRedirect: typeof fetch = async (url, options) => {
	const response = await fetch(url, options);
	if (response.status === 401) {
		const redirect = encodeURIComponent(window.location.href);
		window.location.assign(
			`${import.meta.env.VITE_AUTH_HOSTNAME}/login?redirect_uri=${redirect}`,
		);
		// Return a never-resolving promise to prevent TRPC from processing the error
		return new Promise(() => {});
	}
	return response;
};

export const trpc = createTRPCProxyClient<AppRouter>({
	transformer: superJSON,
	links: [
		link({
			url: `${window.location.origin}/trpc`,
			fetch: fetchWithAuthRedirect,
		}),
	],
});

export type AppRouterInputs = inferRouterInputs<AppRouter>;
export type AppRouterOutputs = inferRouterOutputs<AppRouter>;
